import React from "react";
import { Link } from "react-router-dom";

const SlideShowNavBar = () => {
  return (
    <>
      <ul>
        <li>
          <Link to="/allSlideImages">See All Slide Show Images</Link>
        </li>
      </ul>
    </>
  );
};

export default SlideShowNavBar;
